export const SHOW = "kyotech/toast/SHOW";
export const DISMISS = "kyotech/toast/DISMISS";
